import React, { useState, useEffect } from 'react'
import { Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import axios from 'axios'
import Select from 'react-select'
import { useStyles } from '../styles'

// components
import Dialog from '../../../../../components/Dialog'


export default function JobFunctionFormDlg(props) {

	const classes = useStyles()
	const [err, setErr] = useState('')
	const [selectedFunction , setSelectedFunction] = useState(null)
	const [functionSelectableValues , setFunctionSelectableValues] = useState([])


	useEffect(() => {
		axios('/api/job_functions')
			.then((res) => {
				const jobFunctions = res.data.data.map(d => {
					return { value: d.job_function, label: d.job_function }
				})
				setFunctionSelectableValues(jobFunctions)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [])

	const saveFunction = async () => {
		setErr('')

		if(selectedFunction === null) {
			setErr('Select a function')
			return
		}

		const payload = {
			name: selectedFunction.value,
			type : 'job_function',
		}

		try {
			const res = await axios.post(`/api/company_data`, payload)
			const newFunction = res.data.data
            props.onSuccess({value: newFunction.id, label: newFunction.name})
        } catch(e) {
            setErr('Sorry, we are unable to add function')
        }
	}


	return (
		<Dialog
			size={'sm'}
			title={'Add New Function To Your Company'}
			isOpen={props.isOpen}
			onClose={() => props.onClose()}
			actions={[
				{
					title: 'Cancel',
					func: () => {
						props.onClose()
					},
				},
				{
					title: 'Add',
					func: async () => {
						await saveFunction()
					},
				},
			]}
		>
			<div className={classes.selectionArea}>
				{
					err ?
						<Typography>{err}</Typography>
						:
						null
				}
				<Select
					value={selectedFunction}
					onChange={(newSelectedFunction) => setSelectedFunction(newSelectedFunction)}
					options={functionSelectableValues}
				/>
			</div>
		</Dialog>
	)
}

JobFunctionFormDlg.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
}
